let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("fkMdp")]).then(() => parcelRequire('1q8gp'));